// extracted by mini-css-extract-plugin
export const mainContainer = "Styles-module--mainContainer--1Ch-X";
export const overlay = "Styles-module--overlay--1yI0X";